import { isEscape, returnFocus, trapFocus, throttle } from "./app/utils.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

var returnFocusTo = window.returnFocusTo || null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
        closeSubmenus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

/*
Navigation
*/
const menuOpenButton = document.querySelector('.site-navigation-open');
const menuCloseButton = document.querySelector('.site-navigation-close');
menuOpenButton.addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.add('navigation-open');
    menuOpenButton.setAttribute('aria-expanded', 'true');
    menuCloseButton.setAttribute('aria-expanded', 'true');
});

menuCloseButton.addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.remove('navigation-open');
    menuOpenButton.setAttribute('aria-expanded', 'false');
    menuCloseButton.setAttribute('aria-expanded', 'false');
    const openItems = document.querySelectorAll('.menu-item-has-children.is-open');
    openItems.forEach(item => {
        item.classList.remove('is-open');
    });
});

const parentMenuItems = document.querySelectorAll('.menu-item-has-children');
parentMenuItems.forEach(item => {
    const link = item.querySelector('a');

    // wrap the sub-menu in another container for enhanced features
    const subMenu = item.querySelector('.sub-menu');
    const subMenuWrapper = document.createElement('div');
    subMenuWrapper.classList.add('sub-menu-wrapper');
    subMenu.parentNode.insertBefore(subMenuWrapper, subMenu);
    subMenuWrapper.appendChild(subMenu);

    const itemId = item.getAttribute('id');
    const menuItemData = window.menuData[itemId];
    if (menuItemData && menuItemData.description) {
        const description = document.createElement('div');
        description.classList.add('sub-menu__description');
        description.classList.add('prose');

        const heading = document.createElement('div');
        heading.classList.add('sub-menu__description-heading');
        heading.innerHTML = menuItemData.description.heading;
        description.appendChild(heading);

        const text = document.createElement('p');
        text.classList.add('sub-menu__description-text');
        text.innerHTML = menuItemData.description.text;
        description.appendChild(text);

        const button = document.createElement('a');
        button.classList.add('btn');
        button.setAttribute('href', menuItemData.description.button.url);
        button.innerHTML = menuItemData.description.button.title;
        description.appendChild(button);
        subMenuWrapper.prepend(description);
        subMenuWrapper.classList.add('has-description');
    }
    if (menuItemData && menuItemData.project) {
        const project = document.createElement('div');
        project.classList.add('sub-menu__project');
        project.classList.add('project-card');

        const imageContainer = document.createElement('div');
        imageContainer.classList.add('project-card__image');

        const image = document.createElement('img');
        image.setAttribute('src', menuItemData.project.image);
        image.setAttribute('alt', menuItemData.project.title);
        imageContainer.appendChild(image);
        project.appendChild(imageContainer);

        const title = document.createElement('div');
        title.classList.add('project-card__title');

        const link = document.createElement('a');
        link.setAttribute('href', menuItemData.project.link);
        link.classList.add('project-card__link');
        link.innerHTML = menuItemData.project.title;
        title.appendChild(link);
        project.appendChild(title);

        const location = document.createElement('div');
        location.classList.add('project-card__meta');
        if (menuItemData.project.city && menuItemData.project.state) {
            location.innerHTML = menuItemData.project.city + ', ' + menuItemData.project.state;
        } else if (menuItemData.project.city) {
            location.innerHTML = menuItemData.project.city;
        } else if (menuItemData.project.state) {
            location.innerHTML = menuItemData.project.state;
        }
        project.appendChild(location);

        const badge = document.createElement('div');
        badge.classList.add('project-term');
        badge.classList.add('project-card__term');
        badge.innerHTML = 'Featured';
        project.appendChild(badge);
        subMenuWrapper.appendChild(project);
        subMenuWrapper.classList.add('has-project');
    }

    // inject the sub-menu title
    const submenuTitle = document.createElement('div');
    submenuTitle.classList.add('sub-menu__title');
    submenuTitle.innerHTML = link.innerHTML;
    subMenuWrapper.prepend(submenuTitle);

    // inject a back button for mobile
    const backButton = document.createElement('button');
    backButton.classList.add('sub-menu__back');
    backButton.setAttribute('tabindex', -1);
    backButton.innerHTML = 'Back';
    backButton.addEventListener('click', e => {
        e.preventDefault();
        item.classList.remove('is-open');
    });
    subMenuWrapper.prepend(backButton);

    // remove .loading from parent
    const parentNav = document.querySelector('.primary-navigation');
    parentNav.classList.remove('loading');

    link.addEventListener('click', e => {
        e.preventDefault();
        if (window.innerWidth < breakpoints.lg) {
            item.classList.toggle('is-open');
        } else {
            const expanded = link.getAttribute('aria-expanded') === 'true';
            // was closed, now will be open, so set focus on submenu
            if (!expanded) {
                window.returnFocusTo = link;
                trapFocus(link.nextElementSibling, false);
            }
            link.setAttribute('aria-expanded', !expanded);
        }

    });
});

function closeSubmenus() {
    parentMenuItems.forEach(item => {
        const link = item.querySelector('a');
        link.setAttribute('aria-expanded', false);
    });
    returnFocus();
}


/*
Stats Bar Count Up
*/
const statNumbers = gsap.utils.toArray('.stats-bar__value-number');
statNumbers.forEach(el => {
    const rawText = el.textContent.trim();
    const cleaned = rawText.replace(/,/g, '');
    const target = parseFloat(cleaned);

    if (isNaN(target)) return;

    const decimals = (cleaned.split('.')[1] || '').length;
    const hasCommas = rawText.includes(',');

    if (isReduced) return;

    el.textContent = 0;
    const counter = { val: 0 };

    gsap.to(counter, {
        val: target,
        duration: 4,
        ease: 'power2.out',
        scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none none',
        },
        onUpdate() {
            let formatted = counter.val.toFixed(decimals);
            if (hasCommas) {
                const parts = formatted.split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                formatted = parts.join('.');
            }
            el.textContent = formatted;
        },
    });
});

